import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useApp, API } from "../context";

/**
 * Global presence heartbeat. Marks the active explorer online AND reports what
 * game they're currently in (so friends can "Join My Game"). 2-player arcade
 * board games are joinable; everything else is shown as "Playing X" only.
 * Freshness (90s) is enforced server-side, so leaving a game clears it.
 */
const JOINABLE = {
  "/arcade/tic-tac-toe": { label: "Tic-Tac-Toe", game_type: "tic-tac-toe", joinable: true },
  "/arcade/connect-four": { label: "Connect Four", game_type: "connect-four", joinable: true },
  "/arcade/checkers": { label: "Checkers", game_type: "checkers", joinable: true },
  "/arcade/chess": { label: "Chess", game_type: "chess", joinable: true },
};
const SOLO = {
  "/arcade/tetris": "Tetris",
  "/arcade/sudoku": "Sudoku",
  "/arcade/sliding-puzzle": "Sliding Puzzle",
  "/learn/memory-match": "Memory Match",
};

function gameFor(path) {
  if (JOINABLE[path]) return { ...JOINABLE[path], route: path };
  for (const k in SOLO) if (path.startsWith(k)) return { label: SOLO[k], route: path, joinable: false };
  if (path.startsWith("/learn")) return { label: "Learning", route: path, joinable: false };
  return null;
}

export default function PresenceHeartbeat() {
  const { user } = useApp();
  const loc = useLocation();
  const uid = user?.id || user?.email;
  const pathRef = useRef(loc.pathname);
  pathRef.current = loc.pathname;
  const searchRef = useRef(loc.search);
  searchRef.current = loc.search;
  useEffect(() => {
    if (!uid) return undefined;
    const beat = () => {
      const game = gameFor(pathRef.current);
      if (game && game.joinable) {
        try {
          const pin = new URLSearchParams(searchRef.current || "").get("pin");
          if (pin) game.pin = pin;
        } catch { /* ignore */ }
      }
      axios.post(`${API}/friends/presence`, { user_id: uid, ...(game ? { game } : {}) }).catch(() => {});
    };
    beat();
    const id = setInterval(beat, 25000);
    return () => clearInterval(id);
  }, [uid, loc.pathname, loc.search]);
  return null;
}
